import { Facebook, MailOutline, Phone, Room } from '@material-ui/icons';
import React from 'react'
import { Link } from 'react-router-dom';
import styled from "styled-components"
import { mobile } from "../responsive";

const Container = styled.div`
    display: flex;
    background-color: #0039a6;
    color: white;
    ${mobile({ flexDirection: "column" })}
`;
const Left = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
`;
const Logo = styled.h1`

`;
const Desc = styled.p`
    margin: 20px 0px;
`;
const SocialContainer = styled.div`
    display: flex;
`;
const SocialIcon = styled.h1`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: white;
    background-color: #${props=>props.color};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;
`;
const Center = styled.div`
    flex: 1;
    padding: 20px;
    ${mobile({ display: "none" })}
`;
const Title = styled.h3`
    margin-bottom: 30px;
`;
const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
`;
const ListItem = styled.li`
    width: 50%;
    margin-bottom: 10px;
`;
const Right = styled.div`
    flex: 1;
    padding: 20px;
    
`;
const ContactItem = styled.div`
    margin-bottom: 20px;
    display: flex;
    align-items: center;
`;
const Payment = styled.img`
    width: 70%;
    height: 35%;
`;

const Footer = () => {
  return (
    <Container>
        <Left>
            <Logo>ORION RENTAL</Logo>
            <Desc>
            Orion Equipment Rental, is a family owned and operated business that has all the right tools to complete your projects. We Rent a full line of trucks, trailers, and equipment. We also sell boxes and moving supplies.
            <br/> <br/>
                Store Hours: <br/>
                Monday - Saturday: 8 AM - 5 PM <br/>
                Sunday: Closed
            </Desc>
            <SocialContainer>
                <SocialIcon color="3B5999">
                    <a href='https://www.facebook.com/Orionrentalequipment' style={{ color: 'white', marginBottom: '-1.5px' }}>
                        <Facebook/>
                    </a>
                </SocialIcon>
                {/*<SocialIcon color="E4405F">
                    <Instagram/>
                </SocialIcon>
                <SocialIcon color="55ACEE">
                    <Twitter/>
                </SocialIcon>
                <SocialIcon color="E60023">
                    <Pinterest/>
                </SocialIcon>*/}
            </SocialContainer>
        </Left>
        <Center>
            <Title>Most Popular Items</Title>
            <List>
                <ListItem><Link to='/catalog/miniskidsteer' style={{color: 'white', fontWeight: '500'}}>Mini Skid Steer</Link></ListItem>
                <ListItem><Link to='/catalog/trackloader' style={{color: 'white', fontWeight: '500'}}>Track Loader</Link></ListItem>
                <ListItem><Link to='/catalog/wheelloader' style={{color: 'white', fontWeight: '500'}}>Wheel Loader</Link></ListItem>
                <ListItem><Link to='/catalog/compactor' style={{color: 'white', fontWeight: '500'}}>Compactor</Link></ListItem>
                <ListItem><Link to='/catalog/concretebuggy' style={{color: 'white', fontWeight: '500'}}>Concrete Buggy</Link></ListItem>
                <ListItem><Link to='/catalog/sodcutter' style={{color: 'white', fontWeight: '500'}}>Sod Cutter</Link></ListItem>
                <ListItem><Link to='/catalog/logsplitter' style={{color: 'white', fontWeight: '500'}}>Log Splitter</Link></ListItem>
                <ListItem><Link to='/catalog/pressurewasher' style={{color: 'white', fontWeight: '500'}}>Pressure Washer</Link></ListItem>
                <ListItem><Link to='/catalog/appliancedolly' style={{color: 'white', fontWeight: '500'}}>Appliance Dolly</Link></ListItem>
                <ListItem><Link to='/catalog/pontoontrailer' style={{color: 'white', fontWeight: '500'}}>Pontoon Trailer</Link></ListItem>
            </List>
        </Center>
        <Right>
            <Title>Contact</Title>
            <ContactItem>
                <a href='https://goo.gl/maps/KBLv6SpjhqAUoNmf9' style={{color: 'white'}}>
                    <Room style={{marginRight:"8px", marginBottom:"-6px", color: "white"}}/> 237 W. Clarkston Rd, Lake Orion, MI 48362
                </a>
            </ContactItem>
            <ContactItem>
                <Phone style={{marginRight:"10px"}}/> Office Number: 248-693-5962
            </ContactItem>
            <ContactItem>
                <MailOutline style={{marginRight:"10px"}}/> Email: orionrental@sbcglobal.net
            </ContactItem>
            <Payment src='../images/payment.jpg'/>
        </Right>
    </Container>
  )
}

export default Footer